export default {
  header: 'Utwórz część jednorazową',
  subHeader: 'Utwórz jednorazową część do wykorzystania w raporcie jakości',
};
